import check from "@/assets/check.svg";
import { Color } from "@skillscratch/shared-constants";
import type { InputHTMLAttributes, ReactNode } from "react";
import classes from "./CheckBox.module.scss";

export interface CheckBoxProps
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    "onChange" | "checked" | "value"
  > {
  checked: boolean;
  onChange: (checked: boolean) => void;
  text?: ReactNode;
  backgroundColor?: string;
  color?: string;
}

export function CheckBox({ 
  checked, 
  onChange, 
  text, 
  backgroundColor = "#fff", 
  color = Color.blue,
  ...props 
}: CheckBoxProps) {

  return (
    <label
      style={{
        ...(text !== undefined
          ? { display: "grid", gridTemplateColumns: "auto 1fr", gap: "1rem" }
          : {}),

        fontFamily: "inherit",
        boxSizing: "border-box",
        fontSize: "1rem", // Changed to 1rem to match text-md
        lineHeight: "1.5", // Standard line height for medium text
      }}
    >
      <input
        className={classes.checkbox}
        style={{
          "--form-control-color": color,
          "--checkmark-image": `url("${check}")`,
          boxSizing: "border-box",
          width: "1.25rem", // Adjusted to match text-md size
          height: "1.25rem", // Adjusted to match text-md size
          margin: "0",
          padding: "0",
          backgroundColor: backgroundColor,
          borderRadius: "0.25rem", // Standard border radius for medium components
          // border: theme === "light" ? "0.17em solid #D9D9D9" : undefined,
        }}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        {...props}
      />
      {text && (
        <span style={{ whiteSpace: "preserve-breaks", alignSelf: "center" }}>
          {text}
        </span>
      )}
    </label>
  );
}